'use strict';

export const volunteerOtherElements = () => ({
    select: document.querySelector('select[name="volunteerChoices"]'),
    other: document.querySelector('div#other'),
    otherInput: document.querySelector('input[name="volunteerChoiceOther"]')
});
